import React from "react"
import {useTheme, Paper} from "@mui/material"
import Grid from "@mui/material/Grid2"

import {orangeBackgroundColor, whiteBackgroundColor} from "../../../constants"
import {BillingAddressSection} from "./BillingAddressSection"
import {VaultElementsSection} from "./VaultElementsSection";
import {AccessorySection} from "./AccessorySection";
import {Alerts} from "../../Alerts";
import {validatePlan, validateProject} from "../../../validation/vault/messages/validation";
import {useSelector} from "react-redux";

export const OrderStep: React.FC = () => {
    const theme = useTheme()
    const plan = useSelector((state: any) => state.plan);
    const project = useSelector((state: any) => state.project);
    const errors = [...validateProject(plan, project), ...validatePlan(plan)];

    return (

        <Grid container spacing={1}>
            {
                errors && errors.length > 0
                && <Paper square={true} sx={{
                    background: whiteBackgroundColor, padding: theme.spacing(6), width: '100%',
                }}
                >
                    <Grid container spacing={6} size={12}>
                        {errors && errors.length > 0 && <Alerts errors={errors}/>}
                    </Grid>
                </Paper>
            }

            <Paper
                square={true}
                sx={{
                    background: orangeBackgroundColor,
                    padding: theme.spacing(6)
                }}
            >
                <Grid container spacing={6}>
                    <BillingAddressSection/>
                    <VaultElementsSection/>
                    <AccessorySection/>
                </Grid>
            </Paper>
        </Grid>
    )
}
